import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import CamposCereal from './CamposCereal'

function NuevoCereal (props) {
  const { handleAdd } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleAdd}
          title='Agregar nuevo cereal'
          content={<CamposCereal />}
        />
      </Dialog>
      <Button
        variant='contained'
        color='primary'
        onClick={handleOpen}
      >
            Nuevo cereal
      </Button>
    </>
  )
}

export default NuevoCereal
